export function confirmationCodeSentMessage(userPrefersVoiceCalls: boolean) {
	return userPrefersVoiceCalls
		? `We'll call you with a 6-digit security code.`
		: `We've sent a text message to your mobile with a 6-digit security code.`;
}
